import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  Switch,
  VStack,
  useToast,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import axios from "axios";
import { api_url } from "../../../url";
import CustomSwitch from "../CustomSwitch";

export default function AddProviderModal({ isOpen, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    providerId: "",
    aggregator: "",
    status: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const payload = { ...formData };

      const { data } = await axios.post(`${api_url}/providers`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (data.success) {
        toast({
          title: "Provider added successfully",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        setFormData({
          name: "",
          slug: "",
          providerId: "",
          aggregator: "",
          status: true,
        });
        onSuccess();
        onClose();
      }
    } catch (error) {
      toast({
        title: "Error adding provider",
        description: error.response?.data?.message || "Something went wrong",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Add New Provider</ModalHeader>
        <ModalCloseButton />
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <VStack spacing={4}>
              <FormControl isRequired>
                <FormLabel>Provider Name</FormLabel>
                <Input
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="e.g. Evolution Gaming"
                />
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Slug</FormLabel>
                <Input
                  name="slug"
                  value={formData.slug}
                  onChange={handleChange}
                  placeholder="e.g. evolution-gaming"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Provider ID</FormLabel>
                <Input
                  name="providerId"
                  value={formData.providerId}
                  onChange={handleChange}
                  placeholder="External Provider ID"
                />
              </FormControl>

              <FormControl>
                <FormLabel>Aggregator</FormLabel>
                <Input
                  name="aggregator"
                  value={formData.aggregator}
                  onChange={handleChange}
                  placeholder="Aggregator Name"
                />
              </FormControl>

              <FormControl display="flex" alignItems="center">
                <FormLabel htmlFor="status-switch" mb="0">
                  Provider Status
                </FormLabel>
                <CustomSwitch
                  name="status"
                  isChecked={formData.status}
                  onChange={handleChange}
                />
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="blue" type="submit" isLoading={loading}>
              Add Provider
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
